var Prechat = new (class Prechat extends AbstractModule {

  constructor() {
    super("Prechat");
    this.current = 0;
  }

  _initData(data) {
    this._autoInit({
      "questions": [ data.guest.prechat_questions, [] ]
    });
  }


  get count() {
    return this.questions.length;
  }


  /**
   * enterState
   * @param  {Conversation} conversation
   * @return {Promise}      true: At least one prechat question has been prompted
   *                        false: No question was prompted
   */
  enterState(conversation) {
    return new Promise((resolve, reject) => {
      if (this.count > 0 && !conversation.existsOnServer()) {
        Utils.logState(conversation, 'Prechat');
        conversation.storePromise(resolve, reject, 'prechat');
        this.renderPrechatQuestions(conversation);
      }
      else {
        resolve(false);
      }
    });
  }

  renderPrechatQuestions(conversation) {
    Dom.switchFooter('footer');

    // End prechat questions if no more questions
    if (this.current >= this.count) {
      this._endPrechat(conversation);
      return null;
    }
    let prechat_question = this.questions[this.current]

    // Skip to next question if we already know this info
    if (!this._shouldAsk(prechat_question)) {
      this.current += 1
      this.renderPrechatQuestions(conversation);
    }

    // Ask question
    else {
      this.questions_asked = true;
      let type = 'text';

      if (prechat_question.attr == 'email' || prechat_question.kind == 'email') {
        type = 'email';
      }

      let message = new Message(MS.bot);
      message.type = "notification";
      message.mandatory_buttons = true;
      message.plain_text = prechat_question.label;

      if (!prechat_question.enable_multiple_choices) {
        message.text = `
          ${this.app._askTechParser.mdToHtml(prechat_question.label)}
          <form id="slaask-prechat-question-form-${prechat_question.id}">
            <input id="slaask-prechat-question-input" name="response" class="slaask-input slaask-input-survey" placeholder="${prechat_question.question_placeholder}" type="${type}" value="" required="required"/>
            <span id="slaask-prechat-question-form-${prechat_question.id}-error" class="slaask-error-span"></span>
            <input type="submit" class="slaask-btn" style="background-color: #fff!important;color:${this.app._chat_text_color}" id="slaask-rating-sutmit" value="${prechat_question.submit_text}"/>
          </form>`;

        message.addInteraction({
          selector: '#slaask-prechat-question-form-' + prechat_question.id,
          event: 'submit',
          handler: e => {
            e.preventDefault();
            let form = e.currentTarget;
            let response = form.response.value;
            let error = false;
            if (response) {
              if (prechat_question.kind == 'name' || prechat_question.attr == 'name') {
                if (response.length > 254) {
                  message.getElement().querySelector('#slaask-prechat-question-form-' + prechat_question.id + '-error').innerHTML = "<b>Your name is too long</b>";
                  form.response.value = '';
                  form.response.focus();
                  error = true;
                }
                else Utils.deepSet(this.app._user_infos, ['display_name'], response);
              } else {
                Utils.deepSet(this.app._user_infos, ['more', prechat_question.attr], response);
              }

              if (!error) {
                let temp = document.createElement('div');
                temp.innerHTML = message.text;
                Utils.removeElement(temp.querySelector('form'));
                message.text = temp.innerHTML;
                message.mandatory_buttons = false;
                Conversations.updateMessage(message);

                let responseMessage = new Message(MS.visitor, response);
                conversation.addMessage(responseMessage);
                this.renderPrechatQuestions(conversation);
              }
            }
          }
        });
      } else {
        message.text = this.app._askTechParser.mdToHtml(prechat_question.label);
        for (var idx = 0; idx < prechat_question.multiple_choices.length; idx++) {
          let choice = prechat_question.multiple_choices[idx];
          message.text += `<button id='asktech-prechat-choice${idx}' value='${choice}' class='asktech-prechat-choice-${prechat_question.id} slaask-btn' style="background-color: #fff!important;color:${this.app._chat_text_color}">${choice}</button>`;
        }
        message.addInteraction({
          selector: ".asktech-prechat-choice-" + prechat_question.id,
          event: 'click',
          printResponse: e => e.currentTarget.value,
          removeButtons: true,
          handler: e => {
            e.preventDefault();
            let choice = e.currentTarget;
            Utils.deepSet(this.app._user_infos, ['more', prechat_question.attr], choice.value)

            this.renderPrechatQuestions(conversation);
          }
        });
      }

      message.focus = '#slaask-prechat-question-input';

      conversation.addMessage(message);

      this.app._triggerInternalEvent('recieved_prechat_question', { 'message': prechat_question.title });

      this.current += 1;
    }
  }

  renderCustomQuestion(conversation, type, fieldName, md, m_infos) {
    return new Promise((resolve, reject) => {
      let prechat_question_html;

      if (fieldName == 'name' || fieldName == 'email') {
        if (fieldName == 'name') { fieldName = Wording.name_text }
        else if (fieldName == 'email') { fieldName = Wording.email_text.toLowerCase(); }
      }

      if (type === "boolean") {
        prechat_question_html = `
          ${this.app._askTechParser.mdToHtml(md)}
          <form id="slaask-ask-form" class="slaask-mandatory-buttons">
            <select id="slaask-ask-input" class="slaask-input slaask-input-survey" placeholder="${fieldName}" type="${type}" value="" required="required">
              <option value="true">
                ${Wording.button_value_yes}
              </option>
              <option value="false">
                ${Wording.button_value_no}
              </option>
            </select>
            <input type="submit" class="slaask-btn" style="background-color: #fff!important;color:${this.app._chat_text_color}" id="slaask-rating-sutmit" value="${Wording.replace('confirm_text')}"/>
          </form>`;
      } else {
        prechat_question_html = `
          ${this.app._askTechParser.mdToHtml(md)}
          <form id="slaask-ask-form" class="slaask-mandatory-buttons">
            <input id="slaask-ask-input" class="slaask-input slaask-input-survey" placeholder="${fieldName}" type="${type}" value="" required="required"/>
            <input type="submit" class="slaask-btn" style="background-color: #fff!important;color:${this.app._chat_text_color}" id="slaask-rating-sutmit" value="${Wording.replace('confirm_text')}"/>
          </form>`;
      }

      let message         = new Message(MS.bot, prechat_question_html);
      message.name        = m_infos.name;
      message.image       = m_infos.picture;
      message.focus       = '#slaask-ask-input';
      message.plain_text  = this.app._askTechParser.mdToHtml(md)

      message.addInteraction({
        selector: '#slaask-ask-form',
        event: 'submit',
        removeButtons: true,
        printResponse: event => {
          let responseInput = event.currentTarget.querySelector('#slaask-ask-input');
          if (type === "boolean") {
            return responseInput.selectedOptions[0].innerHTML;
          }
          else {
            return responseInput.value;
          }
        },
        handler: e => {
          e.preventDefault();
          let responseInput = event.currentTarget.querySelector('#slaask-ask-input');
          if (type === "boolean") {
            resolve(responseInput.selectedOptions[0].innerHTML);
          }
          else {
            resolve(responseInput.value);
          }
        }
      });

      Conversations.get(conversation).addMessage(message);

      this.app._triggerInternalEvent('recieved_prechat_question', { 'message': md });
    });

  }

  _shouldAsk(prechatQuestion) {
    let shouldAsk;
    if (prechatQuestion.kind == 'name' || prechatQuestion.attr == 'name') {
      shouldAsk = !(this.app._user_infos && this.app._user_infos['display_name'] && this.app._user_infos['display_name'].split('-#')[0] != 'Visitor')
    } else {
      shouldAsk = !Utils.deepGet(this.app._user_infos, ['more', prechatQuestion.attr])
    }
    return shouldAsk;
  }

  _endPrechat(conversation) {
    this.app._default_infos = {
      'key': this.app._api_key,
      'token': this.app._guest_token,
      'user_infos': this.app._user_infos,
      'current_page': Dom.parent.location.href
    };

    Ajax.call('/api/update_visitor', this.app._default_infos);

    this.current += 1;

    this.app._triggerInternalEvent('ended_prechat_questions', {});

    conversation.resolvePromise(this.questions_asked, 'prechat');
  }

});
